import { gql } from "@apollo/client";

export const mutationDeleteUseCase = gql`
  mutation DeleteUseCase($useCaseKey: String!) {
    cloudPlatform {
      deleteUseCase(useCaseKey: $useCaseKey)
    }
  }
`;
